import portraitCarousel from 'components/portraitCarousel';
import landscapeCarousel from 'components/landscapeCarousel';
import belowTheFold from 'video/belowTheFold';
import WatchlistCta from 'components/watchlist/WatchlistCta';
import PreferencesCta from 'components/preferences/PreferencesCta';
import setVideoPrivacyModalHandler from './setVideoPrivacyModalHandler';
import AnonAgeGate from '../shared/AnonAgeGate';
import { setSearchIconToPreviousPage } from '../helpers/searchPageHelper';
// if coming from search, retain previous results if user navigates back
setSearchIconToPreviousPage();

try {
    new WatchlistCta();
} catch (e) {
    console.error('Watchlist cta failed to load', e);
}

if (typeof kidsAgeGate !== 'undefined' && kidsAgeGate) {
    try {
        new AnonAgeGate();
    } catch (e) {
        console.error('Failed to set Age Gate popup', e);
    }
}

try {
    new PreferencesCta();
} catch (e) {
    console.error('Preferences cta failed to load', e);
}

const brazeCampaignParams = { screenName: 'movie detail' };

try {
    landscapeCarousel({
        parentContainer: $('#extras-carousel'),
        options: {
            endPoint: '/movies/xhr/moviepage/extras/{contentID}/offset/{offset}/limit/{limit}/',
            useBuffer: false,
            params: {
                contentID: $('#extras-carousel').data('id'),
            },
        },
    });
} catch (e) {
    console.error('Movie Extras carousel failed to load');
}

try {
    let urlPrefix = getRegionOverride();
    urlPrefix = urlPrefix ? `/${urlPrefix}/` : '/';

    portraitCarousel({
        parentContainer: $('#ymal-carousel'),
        options: {
            endPoint: urlPrefix + 'movies/xhr/moviepage/ymal/{contentID}/',
            useBuffer: false,
            params: {
                contentID: $('#ymal-carousel').data('id'),
            },
        },
    });
} catch (e) {
    console.error('You Might Also Like carousel failed to load');
}

// movies-carousel
try {
    const moviesCarousel = $('#movies-carousel');

    if (moviesCarousel.length > 0) {
        portraitCarousel({
            parentContainer: $('#movies-carousel'),
            options: {
                endPoint: '/movies/xhr/moviepage/movies/',
                useBuffer: false,
            },
        });
    }
} catch (e) {
    console.error('Movies carousel failed to load');
}

try {
    const trailerContentID = $('#trailerCarouselMount').data('id');

    if (trailerContentID) {
        landscapeCarousel({
            parentContainer: $('#trailer-carousel'),
            options: {
                endPoint: '/movies/xhr/moviepage/trailer/{contentID}/',
                useBuffer: false,
                params: {
                    contentID: trailerContentID,
                },
            },
        });
    }
} catch (e) {
    console.error('Movie trailer carousel failed to load: ', e);
}

try {
    landscapeCarousel({
        parentContainer: $('#full-length-movie-carousel'),
        options: {
            endPoint: '/movies/xhr/moviepage/full-length-movie/{contentID}/',
            useBuffer: false,
            params: {
                contentID: $('#fullLengthdMovieCarouselMount').data('id'),
            },
        },
    });
} catch (e) {
    console.error('Full length movie carousel failed to load: ', e);
}

if (typeof isKidsContent !== 'undefined' && !isKidsContent) {
    // Trigger braze event for movie page view
    if (CBS.Registry.MovieTitle) {
        if (CBS.Registry.Features.braze_sdk === true)
            import('shared/braze_events/events').then(({ onShowMoviePageView }) => {
                brazeCampaignParams['movieName'] = CBS.Registry.MovieTitle;
                onShowMoviePageView(CBS.Registry.MovieTitle, brazeCampaignParams);
            });
    }
}

document.addEventListener('DOMContentLoaded', function () {
    setVideoPrivacyModalHandler();
});

function getRegionOverride() {
    let url = window.location.pathname.split('/');
    if (url[1] !== undefined && url[1].match(/^[A-Za-z]{2}$/)) {
        return url[1];
    }

    if (CBS.Registry.region.international) {
        const regionalPrefix = CBS.Registry.region.property.toLowerCase() ?? null;
        if (regionalPrefix) {
            return regionalPrefix;
        }
    }

    return '';
}
